import type { HttpClient } from '@remodeling/base';
import { GetRemoteConfigRequest, GetRemoteConfigResponse } from '../../model';

/**
 * 리모트 컨피그 단일 조회 — GET /api/v1/configs/{key}
 *
 * 미등록 key 는 HTTP 200 + data: null.
 */
export class GetRemoteConfigGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec<TValue = unknown>(req: GetRemoteConfigRequest) {
    return await this.httpClient.request<GetRemoteConfigResponse<TValue>>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${
        process.env.NEXT_PUBLIC_GW_PATH_PREFIX
      }/display-service/api/v1/configs/${encodeURIComponent(req.key)}`,
    });
  }
}
